import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";

export default class CleanWhitespaceBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.cleanWhitespace = {
            init: (node: HTMLElement) => {
                $(node).contents().filter((index, htmlElement) => {
                    return (htmlElement.nodeType == 3 && !/\S/.test(htmlElement.nodeValue));
                }).remove();
            }
        };
    }
}